// see: https://github.com/nuxt/nuxt.js/issues/213
import { sync } from 'vuex-router-sync';
export default ({ app: { store, router } }) => {
  sync(store, router);
};
